import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Empty, Grid, Modal, Skeleton, Space, Switch, Table, TablePaginationConfig, Tooltip } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import {
    EventsFilterFormPaginated,
} from 'features/events';
import { Organizer } from 'features/events/components/event-organizer/types';
import { useEventActiveStatus } from 'features/events/use-cases/event-active-status';
import { useEventDeleteStatus } from 'features/events/use-cases/event-delete-status';
import { Dispatch, SetStateAction, useState } from 'react';

import { AddAutoDiscountModal } from './auto-discount-add-modal/add-auto-discount-modal';





const { useBreakpoint } = Grid;

type OrganizerTableProps = {
    id: any;
    isLoading: boolean;
    data?: any;
    tableParams: EventsFilterFormPaginated;
    updateParams: Dispatch<SetStateAction<EventsFilterFormPaginated>>;
    refetch: () => void;
    setTrackdata: any,
    trackdata: any
};

export const AutoDiscountTable = ({
    id,
    data,
    isLoading,
    tableParams,
    updateParams,
    refetch,
    setTrackdata,
    trackdata
}: OrganizerTableProps) => {
    const screens = useBreakpoint();

    const handleTableChange = (
        pagination: TablePaginationConfig,
        // filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Organizer> | SorterResult<Organizer>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    const [showAddEventModal, setShowAddEventModal] = useState<boolean>(false);

    const handleCloseModal = () => {
        setShowAddEventModal(false);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = (record: any) => {
        setShowAddEventModal(true);
        setTrackdata(record)
        document.body.style.overflow = 'hidden';
    }


    const { isLoading: deleteLoading, mutate } = useEventDeleteStatus();

    const { mutate: updateStatusMutate, isLoading: statusLoading } = useEventActiveStatus();

    const { confirm } = Modal;

    const showDeleteConfirm = (record: any) => {
        confirm({
            title: 'Are you sure you want to delete this item?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete(record.id);
            },
        });
    };

    const handleDelete = (deleteId: any) => {

        const deletedFormData = {
            id: deleteId,
            status: false,
            flag: "AUTO_DISCOUNT_DELETE"
        }
        mutate(deletedFormData);
    }

    const handleUpdateStatus = (updateId: any, isChecked: any) => {
        const statusFormData = {
            id: updateId,
            status: isChecked,
            flag: "AUTO_DISCOUNT_STATUS"
        }
        updateStatusMutate(statusFormData);
    }


    return (
        <>
            <div className={`cstmrightmdl ${showAddEventModal && "show"}`}>
                <AddAutoDiscountModal id={id} showAddEventModal={showAddEventModal} trackdata={trackdata} refetch={refetch} onClose={handleCloseModal} />
            </div>

            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge
                        text={'Discount Found'}
                        count={data?.total || 0}
                    />

                </StyledTableHeader>
                <Table<Organizer>
                    locale={{
                        emptyText: isLoading ? <Skeleton active={true} /> : <Empty />
                    }}
                    loading={isLoading && { indicator: <div><TableLoader /></div> }}
                    dataSource={isLoading ? [] : data?.items}
                    rowKey='id'
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: data?.total,
                    }}
                    className='layout_table cstltblwthldr'
                >
                    <Column<Organizer>
                        title={'S.No'}
                        key="serialNumber"
                        width={100}
                        ellipsis
                        render={(text, record, index) => index + 1}
                    />

                    <Column<Organizer>
                        title={'Discount Name'}
                        dataIndex={'title'}
                        width={screens.xxl ? 'auto' : 240}
                        ellipsis
                    />
                    <Column<Organizer>
                        title={'Threshold'}
                        dataIndex={'threshold'}
                        width={screens.xxl ? 'auto' : 240}

                    />

                    <Column<Organizer>
                        title={'Discount Percentage'}
                        dataIndex={'discount_percentage'}
                        width={screens.xxl ? 'auto' : 240}

                    />

                    <Column<Organizer>
                        title={'Description'}
                        dataIndex={'description'}
                        width={screens.xxl ? 'auto' : 240}
                        ellipsis
                    />

                    <Column<Organizer>
                        title={'Action'}
                        width={screens.xxl ? 'auto' : 162}
                        dataIndex={'is_active'}
                        render={(_, record) => (
                            <Space>
                                <Tooltip title="Edit">
                                    <Button shape="circle" icon={<EditOutlined />} onClick={() => handleOpenModal(record)} />
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <Button shape="circle" loading={deleteLoading} icon={<DeleteOutlined />} onClick={() => showDeleteConfirm(record)} />
                                </Tooltip>
                                <Tooltip title="Is Active">
                                    <Switch
                                        defaultChecked={record.is_active}
                                        checked={record.is_active}
                                        loading={statusLoading}
                                        onChange={(isChecked) => {
                                            handleUpdateStatus(record.id, isChecked);
                                            record.is_active = isChecked;
                                        }}

                                    />
                                </Tooltip>
                            </Space>
                        )}
                    />
                </Table>

            </StyledTableWrapper>
        </>
    );
};

